<template>
    <div>
        <b-row>
            <b-col>
                <b-card>
                    <b-card-body>
                        <div style="text-align: center; color: dodgerblue; font-size: 2rem;" class="card-title">21</div>
                        <div style="text-align: center;" class="card-title">Metric 1</div>
                    </b-card-body>
                </b-card>
            </b-col>


            <b-col>
                <b-card>
                    <b-card-body>
                        <div style="text-align: center; color: dodgerblue; font-size: 2rem;" class="card-title">8</div>
                        <div style="text-align: center;" class="card-title">Metric 2</div>
                    </b-card-body>
                </b-card>
            </b-col>


            <b-col>
                <b-card>
                    <b-card-body>
                        <div style="text-align: center; color: dodgerblue; font-size: 2rem;" class="card-title">45</div>
                        <div style="text-align: center;" class="card-title">Metric 3</div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-card>
                    <b-card-body>
                        <div class="card-title">
                            Some graphs here...
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data:() => ({

    }),
    computed:{},
    methods:{},
    mounted(){},
}
</script>

<style>

</style>